import { getPaginated } from '@/api/base'

export const getSensorData = async (sensorUuid, paginationOptions) => {
  const { values: batteryLevelsValues } = await getPaginated({
    path: `sensors/${sensorUuid}/battery_levels`,
    valuePath: 'battery_levels',
    ...paginationOptions,
  })

  const { values: signalQualitiesValues } = await getPaginated({
    path: `sensors/${sensorUuid}/signal_qualities`,
    valuePath: 'signal_qualities',
    ...paginationOptions,
  })

  return {
    signalQualities: signalQualitiesValues,
    batteryLevels: batteryLevelsValues,
  }
}
